module.exports = __webpack_public_path__ + "media/images/illustrations/mover_with_couch_small-1c8ec0f0eeee0461e97fb582cc6d2602.svg";